<template>
    <div>
        <headertermsandConditions />
        <div
        class="px-[10px] tablet:px-[20px] desktop:px-[40px] pb-[100px] pt-[115px] tablet:pt-[110px] laptop:pt-[80px] largeDesktop:pt-[120px]">
            <h4
                class="tablet:text-[20px] laptop:text-[24px] font-semibold font-poppins text-center text-[#333333]">
                Terms and Conditions</h4>
            <div class="min-h-screen w-full pb-[20px] mt-[20px] font-poppins terms-condition-page !bg-white px-[15px] tablet:px-[20px] shadow-custom rounded-[10px] relative z-10"
                v-html="termsAndConditionsResponse?.terms_and_conditions_text">
            </div>
        </div>
        <div class="!absolute bottom-0 left-0 w-full text-center shadow-lg rounded-t-full z-10 flex items-center h-[40px] laptop:h-[50px] justify-center mt-4 mobile:pr-[30px] bg-customBlue-100">
            <p class="select-none tablet:mb-0 mobile:!mb-0 text-white mobile:text-[12px] laptop:text-sm font-roboto">
                Copyright © 2025 MyHappyHome | <a href="/contact-us" class="text-customYellow-100">Contact Us</a>
            </p>
        </div>
    </div>
</template>

<script>
import headertermsandConditions from "../../../components/layouts/header/terms-and-conditions-header.vue";
import { mapActions, mapGetters } from "vuex";
export default {
    components: {
        headertermsandConditions,
    },
    data() {
        return {
        };
    },

    computed: {
        ...mapGetters([
            "termsAndConditionsResponse"
        ]),
    },

    watch: {
        termsAndConditionsResponse: function () {
        }
    },

    mounted() {
        setTimeout(() => {
            document.documentElement.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 500);
        this.getTermsAndConditions({
            "language_code": "en",
            "terms_type": "protection-plan"
        })
    },

    methods: {
        ...mapActions([
            "getTermsAndConditions"
        ]),
    }
};
</script>
<style>
.terms-condition-page .custom-badge {
    position: relative;
    padding-left: 33px;
    font-size: 12px;
}

@media (min-width: 1024px) {
    .terms-condition-page .custom-badge {
        font-size: 14px;
        padding-left: 30px;
    }

    .terms-condition-page .custom-text {
        font-size: 14px !important;
    }

    .terms-condition-page .mb-subheading {
        margin-bottom: 10px;
    }

    .terms-condition-page .custom-heading {
        font-size: 28px;
        margin-bottom: 10px;
    }

    .terms-condition-page .custom-subheading {
        font-size: 16px !important;
    }

    .terms-condition-page .custom-card {
        padding: 15px 10px;
    }

    .terms-condition-page .custom-badge-circle {
        height: 30px;
        width: 30px;
        min-height: 30px;
        min-width: 30px;
        font-size: 16px;
    }

    .terms-condition-page .custom-ml {
        margin-left: 40px;
    }

    .terms-condition-page .custom-card-header {
        gap: 10px !important;
        padding-bottom: 10px;
    }

    .terms-condition-page .text-margin {
        margin-bottom: 15px;
    }

    .terms-condition-page .ul-listing {
        gap: 10px;
        padding-bottom: 15px;
    }

    .terms-condition-page .bold-text {
        margin-bottom: 10px;
    }

    .terms-condition-page .text-mb-2 {
        margin-bottom: 10px;
    }
}

.terms-condition-page .text-mb-2 {
    margin-bottom: 8px;
}

.terms-condition-page .bold-text {
    margin-bottom: 2px;
    font-weight: 700;
}

.terms-condition-page .ul-listing {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.terms-condition-page .text-margin {
    margin-bottom: 8px;
}

/* Heading */
.terms-condition-page .custom-heading {
    font-size: 24px;
    margin-bottom: 0;
    display: none;
}

.terms-condition-page .custom-badge-circle {
    height: 25px;
    width: 25px;
    min-height: 25px;
    min-width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    border-radius: 50%;
    color: #ffffff;
}

/* Subheading */
.terms-condition-page .custom-subheading {
    font-size: 14px;
}

@media (min-width: 1536px) {
    .terms-condition-page .custom-subheading {
        font-size: 18px;
    }

    .terms-condition-page .custom-heading {
        font-size: 30px;
    }
}

@media (min-width: 720px) {
    .terms-condition-page .custom-ml {
        margin-left: 35px;
    }

    .terms-condition-page .custom-badge {
        padding-left: 30px;
    }

    .terms-condition-page .custom-badge::before {
        top: 0px !important;
        left: 0px !important;
    }
}

.terms-condition-page .custom-card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 6px;
}

.terms-condition-page .custom-card {
    width: 100%;
    border-radius: 10px;
    margin-top: 15px;
    padding: 15px;
    background-color: rgba(229, 210, 182, 0.15);
}

/* ::before pseudo-element for badge */
.terms-condition-page .custom-badge::before {
    content: attr(data-label);
    position: absolute;
    top: -1px;
    left: 3px;
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
    color: white;
    background-color: #2459A8;
}

/* If you want a yellow variant */
.terms-condition-page .custom-badge[data-label-type="yellow"]::before {
    background-color: #F5B134;
}

.terms-condition-page .custom-text {
    font-size: 12px;
    font-weight: 400;
}

.terms-condition-page .text-customgray {
    color: #333333;
}

.terms-condition-page .pt-3 .custom-text.text-customgray {
    text-align: justify;
}
</style>